<template>
  <div>
    <template v-if="editSoaIndex === index">
      <button class="bb-button bb-button-column"
              :class="{'bb-button-column_disable': disable}"
              @click="createSoa()"
              :disabled="disable"
      >
        {{buttonText}}
      </button>
    </template>
    <transition name="fade-form">
      <template v-if="editSoaIndex !== index">
        <span>{{convertNumber(soa.balanceAed || 0)}}</span>
      </template>
    </transition>
  </div>
</template>

<script>
import convertNumber from '@/mixin/convertNumber'
export default {
  name: 'ButtonColumn',
  mixins: [convertNumber],
  props: ['buttonText', 'soa', 'editSoaIndex', 'index', 'disable'],
  methods: {
    createSoa () {
      this.$emit('createSoa')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../../sass/variables";
  @import "../../../../../../../../sass/mixins";
  .bb-button-column {
    @include global-font;
    height: 30px;
    width: 57px;

    &_disable {
      background-color: $color-silver;
      color: $color-gray;
      cursor: not-allowed;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/ButtonColumn.vue